import dayjs from "dayjs";
import { clearSession, getNewSession } from "../redux/slice/headerSlice";

import { msalInstance } from "../components/auth/AuthZ";
import { setInvalidATMSUser } from "../redux/slice/headerSlice";
export const msalSessionCheck = async () => {
  const accounts = msalInstance.getAllAccounts();

  if (!accounts.length) {
    return { isExpired: true };
  }

  try {
    await msalInstance.acquireTokenSilent({
      account: accounts[0],
      scopes: ["openid"],
    });

    return { isExpired: false };
  } catch {
    return { isExpired: true };
  }
};

export const sessionCheck = (dispatch: any, getState: any) => {
  const { sessionId, sessionCreatedOn } = getState().header || {};
  if (!sessionId || !sessionCreatedOn) {
    return { isExpired: false, needsInit: true };
  }
  const diff = dayjs().diff(dayjs(sessionCreatedOn));
  if (diff > 60 * 60 * 1000) {
    return { isExpired: true };
  }

  sessionUpdate(dispatch);
  return { isExpired: false };
};

export const sessionCreate = async (dispatch: any, getState: any) => {
  const { sessionId, sessionCreatedOn } = getState().header || {};

  if (sessionId && sessionCreatedOn) {
    return;
  }
  // dispatch(getNewSession());
  // console.log('sessionCreated')
    const res = await dispatch(getNewSession());
 
  const status = res.payload?.status;
  const message1 = res.payload?.message;
  if (status == 403) {
    dispatch(setInvalidATMSUser(true));
    sessionStorage.setItem("skipSessionCheck", "true");
  } else if (status == 422) {
    dispatch(setInvalidATMSUser(false));
    console.error("invalid payload", message1);
  } else if (status == 500) {
    console.error("Something went wrong in getLogin API");
  } else if (status == 200) {
    dispatch(setInvalidATMSUser(false));
    sessionStorage.removeItem("skipSessionCheck");
    console.log("session created");
  }
};

export const fullSessionCheck = async (dispatch: any, getState: any) => {

  const appSession = sessionCheck(dispatch, getState);

  if (appSession.needsInit) {
    return { isExpired: false };
  }

  if (appSession.isExpired) {
    return { isExpired: true };
  }

  const msalSession = await msalSessionCheck();

  if (msalSession.isExpired) {
    return { isExpired: true };
  }

  return { isExpired: false };
};

// export const sessionExpire = async (dispatch: any, getState: any) => {
//   dispatch({ type: "session/clearSession" });
//   await sessionCreate(dispatch, getState);
// };

export const sessionExpire = async (dispatch: any, getState: any) => {
  dispatch(clearSession());
  await sessionCreate(dispatch, getState);
};
const sessionUpdate = (dispatch: any) => {
  dispatch({
    type: "session/updateSessionTime",
    payload: dayjs().toISOString(),
  });
};
